import { Autocomplete, MenuItem, Select, TextField } from '@mui/material';
import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';

export interface SubviewControlConfig {
	paths: Record<string, string>;
	options: string[];
}

export function SubviewControl({ config }: { config: SubviewControlConfig }) {
	const router = useRouter();
	const value = useMemo(() => {
		for (const option in config.paths) {
			if (config.paths[option] === router.pathname) {
				return option;
			}
		}

		return config.options[0];
	}, [router.pathname]);

	const handleSubviewChange = useCallback(
		(value: string) => {
			if (value in config.paths) {
				router.push(config.paths[value]);
			}
		},
		[router],
	);

	return (
		<Select
			size='small'
			sx={{ width: '250px', height: '36px' }}
			value={value}
			onChange={(e) => handleSubviewChange(e.target.value)}
		>
			{config.options.map((option) => (
				<MenuItem key={option} value={option}>
					{option}
				</MenuItem>
			))}
		</Select>
	);
}
